import React from 'react';
import { BottomSheet } from '../../BottomSheet/BottomSheet';
// WHY: a sheet that is the whole modal content portals into the drawer, leaving its host empty but still painting a backdrop under the drawer's own.
export function asHostReplacingSheet(content) {
    if (!React.isValidElement(content) || content.type !== BottomSheet) return content;
    return React.cloneElement(content, {
        replacesHostSurface: true
    });
}
